import React from 'react';
import cn from 'classnames';
import ModalReport from './modal';
import { IconButton } from 'src/components';
import { useModal } from 'src/hooks/useModal';
import styles from './styles.module.scss';
import Button from 'src/components/button';

interface IProps {
    icon?: string;
    textBtn?: string;
    onSubmit: (id: any) => void;
    okText?: string;
    cancelText?: string;
    classNameBtn?: string;
    item: any;
}

const ReportButton = ({ onSubmit, item }: IProps) => {
    const { Modal, show, hide } = useModal();

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        show();
    };

    return (
        <>
            <IconButton
                title="Báo lôi"
                icon="new-circle-close-light"
                className={cn(
                    'btn-report-ad',
                    'flex items-center justify-center',
                    'w-[24px] h-[24px]',
                    'absolute right-0 bottom-1/2 translate-y-1/2',
                    'text-[16px] text-[#D9D9D9]',
                )}
                onClick={handleClick}
            />
            <Modal>
                <ModalReport hide={hide} onSubmit={onSubmit} item={item} />
            </Modal>
        </>
    );
};

export default ReportButton;
